import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import BusComponent from '../BusComponent';

import Popover from '../popover/Popover';

const MARGIN_LEFT = 12;

class AreaSelectorInfoPopover extends BusComponent {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    onToggle = () => {
        this.setState(prevState => ({ open: !prevState.open }));
    };

    render() {
        const { open } = this.state;
        const { intl } = this.props;
        return (
            <div className="flex-it">
                <button
                    ref={e => {
                        this.trigger = e;
                    }}
                    className={classNames(
                        'radius-selector__reset-custom-values-btn',
                        'material-icons',
                        { 'radius-selector__reset-custom-values-btn--active': open },
                    )}
                    onClick={this.onToggle}
                    aria-label={intl.formatMessage({
                        id: 'locationAnalysis.selectAreaInfoPopup.help',
                    })}
                >
                    help_outline
                </button>
                {this.trigger && (
                    <Popover
                        anchorEl={this.trigger}
                        className="radius-selector__reset-custom-values-popover"
                        open={open}
                        marginLeft={MARGIN_LEFT}
                        triggerToggle
                        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                        onCloseRequest={this.onToggle}
                    >
                        <div className="radius-selector__reset-custom-values-popover__container">
                            <p className="radius-selector__reset-custom-values-popover__label">
                                <FormattedMessage id="locationAnalysis.selectAreaInfoPopup.description" />
                            </p>
                            <p className="radius-selector__reset-custom-values-popover__label">
                                <FormattedMessage id="locationAnalysis.selectAreaInfoPopup.maximumSelection" />
                            </p>
                        </div>
                    </Popover>
                )}
            </div>
        );
    }
}

export default injectIntl(AreaSelectorInfoPopover);
